import { c as _c } from "react/compiler-runtime";
import { displayPercentageDiscount } from "@website/accommodation-ui/helpers/calculatePercentageDiscount";
import { InfoChips } from "@website/ui/info-chips";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { AccommodationCardPricingProperties } from "./accommodation-card-pricing.types";
export const AccommodationCardPricing: React.FC<AccommodationCardPricingProperties & {
  showTotalPrice?: boolean;
}> = t0 => {
  const $ = _c(13);
  const {
    price,
    priceOff,
    totalPrice,
    totalPriceOff,
    showTotalPrice
  } = t0;
  const displayPrice = showTotalPrice ? totalPrice : price;
  const displayPriceOff = showTotalPrice ? totalPriceOff : priceOff;
  const hasDiscount = Boolean(displayPriceOff && displayPrice > displayPriceOff);
  const effectivePrice = hasDiscount && displayPriceOff ? displayPriceOff : displayPrice;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      direction: "ltr"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== effectivePrice) {
    t2 = numberConvert(numberSeparator(effectivePrice), {
      locale: "fa"
    });
    $[1] = effectivePrice;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-extra-caption lg:text-overline px-1 font-[400]">تومان</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="text-on-surface-high-emphasis flex flex-row-reverse items-center !text-[14px] font-bold" itemProp="priceRange">{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== displayPrice || $[7] !== displayPriceOff || $[8] !== hasDiscount) {
    t5 = hasDiscount && <div className="flex items-center gap-[2px] px-1"><InfoChips className="!w-[32px] justify-center !p-[2px]" size="medium" text={displayPercentageDiscount(displayPrice, displayPriceOff || 0)} variant="round-accent" /><div className="text-extra-caption text-on-surface-disable font-[400] line-through">{numberConvert(numberSeparator(displayPrice), {
          locale: "fa"
        })}</div></div>;
    $[6] = displayPrice;
    $[7] = displayPriceOff;
    $[8] = hasDiscount;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="accommodation-card-pricing mt-1 flex w-full justify-start gap-[2px]" style={t1}>{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};